import globals from '@descope-ui/theme-globals';
import { getThemeRefs, createHelperVars } from '@descope-ui/common/theme-helpers';
import { componentName, ButtonClass } from './component/ButtonClass';

const globalRefs = getThemeRefs(globals);
const compVars = ButtonClass.cssVarList;

const mode = {
  primary: globalRefs.colors.primary,
  secondary: globalRefs.colors.secondary,
  success: globalRefs.colors.success,
  error: globalRefs.colors.error,
  surface: globalRefs.colors.surface,
};

const [helperTheme, helperRefs, helperVars] = createHelperVars({ mode }, componentName);

const button = {
  ...helperTheme,

  [compVars.fontFamily]: globalRefs.fonts.font1.family,

  [compVars.cursor]: 'pointer',
  [compVars.hostHeight]: '3em',
  [compVars.hostWidth]: 'auto',
  [compVars.hostDirection]: globalRefs.direction,

  [compVars.borderRadius]: globalRefs.radius.sm,
  [compVars.borderWidth]: globalRefs.border.xs,
  [compVars.borderStyle]: 'solid',
  [compVars.borderColor]: 'transparent',

  [compVars.labelSpacing]: '0.25em',

  [compVars.textAlign]: 'center', // default text align center
  textAlign: {
    right: { [compVars.textAlign]: 'right' },
    left: { [compVars.textAlign]: 'left' },
    center: { [compVars.textAlign]: 'center' },
  },

  [compVars.verticalPadding]: '1em',
  [compVars.horizontalPadding]: '0.875em',

  [compVars.outlineWidth]: globals.border.sm,
  [compVars.outlineOffset]: '0px', // keep `px` unit for external calc
  [compVars.outlineStyle]: 'solid',
  [compVars.outlineColor]: 'transparent',

  [compVars.iconSize]: '1.5em',

  size: {
    xs: { [compVars.fontSize]: '12px' },
    sm: { [compVars.fontSize]: '14px' },
    md: { [compVars.fontSize]: '16px' },
    lg: { [compVars.fontSize]: '18px' },
  },

  _square: {
    [compVars.hostHeight]: '3em',
    [compVars.hostWidth]: '3em',
    [compVars.verticalPadding]: '0',
  },

  _fullWidth: {
    [compVars.hostWidth]: '100%',
  },

  _loading: {
    [compVars.cursor]: 'wait',
    [compVars.labelTextColor]: helperRefs.main,
  },

  _disabled: {
    [helperVars.main]: globalRefs.colors.surface.light,
    [helperVars.dark]: globalRefs.colors.surface.dark,
    [helperVars.light]: globalRefs.colors.surface.light,
    [helperVars.contrast]: globalRefs.colors.surface.main,
    [compVars.iconColor]: globalRefs.colors.surface.main,
  },

  variant: {
    contained: {
      [compVars.labelTextColor]: helperRefs.contrast,
      [compVars.backgroundColor]: helperRefs.main,
      _hover: {
        [compVars.backgroundColor]: helperRefs.dark,
        _loading: {
          [compVars.backgroundColor]: helperRefs.main,
        },
      },
      _active: {
        [compVars.backgroundColor]: helperRefs.main,
      },
    },

    outline: {
      [compVars.labelTextColor]: helperRefs.main,
      [compVars.borderColor]: helperRefs.main,
      _hover: {
        [compVars.labelTextColor]: helperRefs.dark,
        [compVars.borderColor]: helperRefs.dark,
      },
      _active: {
        [compVars.labelTextColor]: helperRefs.main,
        [compVars.borderColor]: helperRefs.main,
      },
    },

    link: {
      [compVars.labelTextColor]: helperRefs.main,
      [compVars.horizontalPadding]: '0.125em',
      _hover: {
        [compVars.labelTextColor]: helperRefs.dark,
        [compVars.labelTextDecoration]: 'underline',
      },
      _active: {
        [compVars.labelTextColor]: helperRefs.main,
      },
    },
  },

  _focused: {
    [compVars.outlineColor]: helperRefs.light,
  },
};

export default button;

export const vars = {
  ...compVars,
  ...helperVars,
};
